// The ordering page's bell menu: four switches, each one column on the customer's
// own account.

/** Each switch, and which of the two account routes owns its column. */
export const BELL_SWITCH_ROUTES = {
  reminderEnabled: "reminders",
  smsOrderReceipts: "reminders",
  emailNotificationEnabled: "email-notifications",
  emailOrderReceipts: "email-notifications",
} as const;

export type BellSwitch = keyof typeof BELL_SWITCH_ROUTES;

/**
 * The one PATCH a flipped switch sends: its own column, to the route that owns it.
 *
 * Both routes write every field a body names, and an account's unset columns mean
 * "follow the org". The menu used to send both routes a value for every field —
 * "monday", "wednesday", "08:00" and "" where the account had none — so one switch
 * took the account off its org's reminder days, times and message, and set the three
 * switches the customer had not touched to off.
 */
export function bellToggleRequest(accountId: number, key: BellSwitch, value: boolean) {
  return {
    path: `/api/accounts/${accountId}/${BELL_SWITCH_ROUTES[key]}`,
    body: { [key]: value } as Partial<Record<BellSwitch, boolean>>,
  };
}
